import CompanyInformation from './client-request-company-information/CompanyInformation'

export { CompanyInformation }
